import apiUpdatedNotifier from "./api-updated-notifier";
import onlineNotifier from "./online-notifier";

const deps = [apiUpdatedNotifier, onlineNotifier];

export default angular
	.module("vesl.componenet.environment-notifier", deps)
	.component("environmentNotifier", {
		template: `
      <online-notifier></online-notifier>
      <api-updated-notifier></api-updated-notifier>
      <!-- TODO: implement me -->
      <supported-browser-notifier></supported-browser-notifier>
      <valid-location-notifer></valid-location-notifer>
    `
	})
	.component("notifier", {
		transclude: {
			message: "notifierMessage",
			actions: "?notifierActions"
		},
		template: `
      <div ng-transclude="message" class="notifier-message"></div>
      <div ng-transclude="actions" class="notifier-actions"></div>
    `
	}).name;
